/* eslint-disable class-methods-use-this */
import { makeApi, URLS } from 'Utils/apiUtil';
import { action, observable } from 'mobx';

class AdvSearchFilters {
  @observable filterListValues = {
    sicCode: [],
    naicsCode: [],
    level: [],
    department: [],
  };

  @action
  async getIndustryClassificationFilter() {
    const values = await this.getFilterValues(
      URLS.getIndustryClassification,
      this.generateListForIndustryClassification,
    );

    this.filterListValues = {
      ...this.filterListValues,
      ...values,
    };
  }

  generateListForIndustryClassification = data => {
    const { NAICS_CODE = [], SIC_CODE = [] } = data || {};

    const getList = list => {
      const newList = list.map(item => {
        const newObj = {
          selected: false,
          name: item.code,
          pName: item.code,
          description: item.description,
        };

        return newObj;
      });
      return newList;
    };

    return { sicCode: getList(SIC_CODE), naicsCode: getList(NAICS_CODE) };
  };

  async getFilterValues(url, generateListFunction) {
    const config = {
      url,
      method: 'GET',
    };
    const response = await makeApi(config);

    const list =
      typeof generateListFunction === 'function'
        ? generateListFunction(response.data)
        : this.generateListForDropdown(response.data);

    return list;
  }

  generateListForDropdown = list => {
    const newList = list?.map(item => {
      const newObj = {
        selected: false,
      };
      newObj.name = item;
      newObj.pName = item;
      return newObj;
    }) ?? [];

    return newList;
  };

  getLevel = async () => {
    const values = await this.getFilterValues(URLS.getLevel);
    this.filterListValues = {
      ...this.filterListValues,
      level: values,
    };
  };

  getDepartment = async () => {
    const values = await this.getFilterValues(URLS.getDepartment);
    this.filterListValues = {
      ...this.filterListValues,
      department: values,
    };
  };

  fetchFilterValues = () => {
    this.getIndustryClassificationFilter();
    this.getLevel();
    this.getDepartment();
  };
}

const advSearchFiltersState = new AdvSearchFilters();

export default advSearchFiltersState;
